import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
// import BootstrapTable from 'react-bootstrap-table-next';
// import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import '../subscriptions.css';
// import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
// import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
// import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';


class ViewUser extends Component {
    constructor(props) {
        super(props);
      }

  render() {
    return (

    <div className="modal fade" id="view_user_modal" tabIndex="-1" role="dialog" aria-labelledby="RejectModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">User Details</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                  <div className="modal-body">
                    <div className="col-xl-12 col-md-12 col-sm-12 mx-auto my-0">
                        <div className="m-portlet m-portlet--full-height">
                            <div className="m-portlet__head">
                                <div className="m-portlet__head-caption">
                                    <div className="m-portlet__head-title">
                                        <h3 className="m-portlet__head-text mr-2"> Kavinda Silva</h3>
                                        <span className="m-badge m-badge--info px-2">Emp no. <strong>3244</strong></span>
                                    </div>
                                </div>
                            </div>
                        <div className="m-portlet__body">
                            <div className="m-widget4">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row m--align-center">
                                        <div className="m-widget4__img m-widget4__img--pic my-0 user-avatar mx-auto">
                                            <img src="https://s3.amazonaws.com/uploads.development.petpos/uploads/4/users/avatar/1542214138059_177717.jpg" alt=""/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="m-widget4__item">
                                        <span className="m-widget4__sub">
                                        <i className="fas fa-store mr-2"></i><strong>Petshop: </strong>cat shop</span>
                                    </div>
                                    <div className="m-widget4__item">
                                        <span className="m-widget4__sub">
                                        <i className="fas fa-at mr-2"></i><strong>Email: </strong>kavindasilva2005+778@gmail.com</span>
                                    </div>
                                    <div className="m-widget4__item">
                                        <span className="m-widget4__sub">
                                        <i className="fas fa-genderless mr-2"></i><span><strong>Gender: </strong></span></span>male
                                    </div>
                                    <div className="m-widget4__item">
                                        <span className="m-widget4__sub">
                                        <i className="fas fa-birthday-cake mr-2"></i><span><strong>Birthday: </strong></span></span>2018-11-14
                                    </div>
                                    <div className="m-widget4__item item-last">
                                        <span className="m-widget4__sub">
                                        <i className="fas fa-phone-square mr-2">
                                        </i><strong>Contact No: </strong></span>0772000919
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  user: state.cognito.user,
});


export default withRouter(connect(mapStateToProps)(ViewUser));